<template>
  <Dialog
    header="Selecionar Bovinos"
    :visible="visible"
    @update:visible="$emit('update:visible', $event)"
    :style="{ width: '90vw' }"
    :modal="true"
    :closable="false"
  >
    <template #header>
      <div class="p-grid" style="width: 100%">
        <div class="p-col-12">
          <span class="p-dialog-title">Selecionar Bovinos</span>
        </div>
        <div class="p-col-12">
          <BovineSearch
            @search="search($event)"
            :defaultQuery="defaultQuery"
            :apiOptions="apiOptions"
            optionsHeight="50vh"
          ></BovineSearch>
        </div>
      </div>
    </template>
    <AppSkeletonTable v-show="loadingList"></AppSkeletonTable>
    <DataTable
      v-show="!loadingList"
      dataKey="id"
      responsiveLayout="stack"
      v-model:selection="selectionItems"
      :value="results"
      :scrollable="false"
      @row-select="selectRow($event)"
      @row-unselect="unselectRow($event)"
      @row-select-all="selectAll($event)"
      @row-unselect-all="unselectAll($event)"
      @sort="onSort($event)"
    >
      <Column
        selectionMode="multiple"
        headerStyle="min-width: 60px"
        style="max-width: 60px"
        alignFrozen="left"
        :frozen="true"
      ></Column>
      <Column
        header="Brinco"
        field="earring"
        style="max-width: 90px"
        headerStyle="min-width: 90px"
        alignFrozen="left"
        :frozen="true"
      >
        <template #body="{ data: { earring, id } }">
          <router-link
            :to="{ name: 'bovine.edit', params: { id } }"
            target="_blank"
            style="text-decoration: none"
          >
            {{ earring }}
          </router-link>
        </template>
      </Column>
      <Column
        header="Tipo"
        field="type.name"
        style="max-width: 85px"
        headerStyle="min-width: 85px"
        alignFrozen="left"
        :frozen="true"
      >
        <template #body="{ data: { type, id } }">
          <router-link
            :to="{ name: 'bovine.edit', params: { id } }"
            target="_blank"
            style="text-decoration: none"
          >
            <BovineType :type="type" small />
          </router-link>
        </template>
      </Column>
      <Column header="Raça" style="min-width: 90px" field="breed.name">
        <template #body="{ data: bovine }">
          {{ bovine?.breed?.name || '-' }}
        </template>
      </Column>
      <Column
        header="Data de nascimento"
        field="birthDate"
        style="min-width: 130px"
        headerStyle="min-width: 130px"
      >
        <template #body="slotProps">
          {{
            slotProps.data.birthDate
              ? $dayjs(slotProps.data.birthDate).format('DD/MM/YYYY')
              : '-'
          }}
        </template>
      </Column>
      <Column
        header="Peso"
        field="weight"
        style="max-width: 90px"
        headerStyle="min-width: 90px"
      >
        <template #body="{ data: { weight } }">
          {{ weight ? $toDecimal(weight) : '-' }}
        </template>
      </Column>
      <Column
        header="Status"
        field="status.name"
        style="max-width: 90px"
        headerStyle="min-width: 90px"
      >
        <template #body="slotProps">
          {{ slotProps.data?.status?.name || '-' }}
        </template>
      </Column>
      <Column
        header="Lote/Piquete"
        field="farmLot.name"
        style="min-width: 160px"
        headerStyle="min-width: 160px"
      >
        <template #body="{ data: bovine }">
          <span v-if="bovine?.farmLot?.id">
            <router-link
              :to="{
                name: 'lot.edit',
                params: { id: bovine?.farmLot?.id },
              }"
              target="_blank"
              style="text-decoration: none"
            >
              {{ bovine?.farmLot?.name }}
            </router-link>
          </span>
          <span v-else> - </span>
        </template>
      </Column>
      <Column
        header="Fazenda"
        field="farm.name"
        style="min-width: 110px"
        headerStyle="min-width: 110px"
      >
        <template #body="{ data }">
          <router-link
            v-if="data?.farm?.name"
            :to="{ name: 'farm.edit', params: { id: data?.farmId } }"
            target="_blank"
            style="text-decoration: none"
            >{{ data?.farm?.name }}</router-link
          >
          <span v-else> - </span>
        </template>
      </Column>
      <Column
        header="Matriz"
        style="max-width: 90px"
        headerStyle="min-width: 90px"
        field="bovineRoot.earring"
      >
        <template #body="{ data: bovine }">
          <span v-if="bovine?.bovineRoot?.id">
            <router-link
              :to="{
                name: 'bovine.edit',
                params: { id: bovine?.bovineRoot?.id },
              }"
              target="_blank"
              style="text-decoration: none"
            >
              {{ bovine?.bovineRoot?.earring }}
            </router-link>
          </span>
          <span v-else> - </span>
        </template>
      </Column>
      <Column header="Proprietário" field="owner.name">
        <template #body="{ data }">
          <span v-if="data?.owner?.id">
            <router-link
              :to="{
                name: 'owner.edit',
                params: { id: data?.owner?.id },
              }"
              target="_blank"
              style="text-decoration: none"
              >{{ $sliceText(data?.owner?.name, 15) }}</router-link
            >
          </span>
          <span v-else> - </span>
        </template>
      </Column>
      <!-- <template #empty> Nenhum resultado encontrado. </template> -->
    </DataTable>
    <Paginator
      :rows="query.pageSize"
      :totalRecords="pagination.total"
      @page="changePage($event)"
    ></Paginator>
    <template #footer>
      <Button
        label="Cancelar"
        class="p-button-outlined p-mr-2"
        @click="cancel()"
      />
      <Button
        v-if="showSelectAll"
        :label="
          pagination.total
            ? `Selecionar Todos (${pagination.total})`
            : 'Selecionar Todos'
        "
        @click="confirmAll()"
        :disabled="!pagination.total || loadingConfirm"
      />
      <Button
        class="select-btn"
        :label="selectedCount ? `Selecionar (${selectedCount})` : 'Selecionar'"
        @click="confirm()"
        :disabled="!selectedCount || loadingConfirm"
      />
    </template>
  </Dialog>
</template>

<script>
import { mapActions } from 'vuex';
import useApiList from '../lib/useApiList';
import { BovineApi } from '../services/api';
import BovineType from './BovineType';
import BovineSearch from '../views/Bovine/components/BovineSearch';

const initialQuery = {
  page: 1,
  pageSize: 20,
  order: 'desc',
  orderField: 'id',
  available: true,
  term: '',
};

export default {
  name: 'BovineSelector',
  components: {
    BovineType,
    BovineSearch,
  },
  props: {
    visible: Boolean,
    defaultQuery: {
      type: Object,
      deafult: () => ({}),
    },
    showSelectAll: Boolean,
    apiOptions: Object,
  },
  setup() {
    return {
      ...useApiList(BovineApi),
    };
  },
  data() {
    return {
      selectionItems: [],
      selection: {},
      loadingConfirm: false,
    };
  },
  computed: {
    selectedCount() {
      return Object.keys(this.selection).length;
    },
  },
  watch: {
    results() {
      this.selectionItems = this.results.filter(
        (result) => this.selection[result.id]
      );
    },
    async visible(newValue, oldValue) {
      if (newValue && !oldValue) {
        this.query = { ...initialQuery, ...this.defaultQuery };
        await this.fetchList(undefined, this.apiOptions);
      }
    },
  },
  methods: {
    ...mapActions('app', ['setLoadingCursor']),
    async onSort(event) {
      this.query.order = event.sortOrder === 1 ? 'asc' : 'desc';
      this.query.orderField = event.sortField;
      this.fetchList(undefined, this.apiOptions);
    },
    cancel() {
      this.$emit('update:visible', false);
      this.selection = {};
      this.selectionItems = [];
    },
    confirm() {
      this.$emit('update:visible', false);
      this.$emit('select', { values: [...Object.values(this.selection)] });
      this.selection = {};
      this.selectionItems = [];
    },
    async confirmAll() {
      try {
        this.setLoadingCursor(true);
        this.loadingConfirm = true;
        const query = {
          ...this.query,
          page: 'all',
          available: true,
          includeFields: '[id]',
          include: '[]',
        };
        const callback = () => {
          this.$emit('update:visible', false);
          this.$emit('select', { values: [...this.results] });
          this.selection = {};
          this.selectionItems = [];
          this.loadingConfirm = false;
          this.setLoadingCursor(false);
        };
        await this.searchList(query, callback, this.apiOptions);
      } catch (error) {
        console.error(error);
        this.loadingConfirm = false;
        this.setLoadingCursor(false);
      }
    },
    async changePage({ page }) {
      await this.changeListPage({ page: page + 1 }, this.apiOptions);
    },
    async search({ query }) {
      const { page, pageSize } = this.query;
      this.query = { ...query, page, pageSize, ...this.defaultQuery };
      await this.searchList(this.query, undefined, this.apiOptions);
    },
    selectRow({ data }) {
      this.selection[data.id] = data;
    },
    unselectRow({ data }) {
      delete this.selection[data.id];
    },
    selectAll() {
      this.results.forEach((data) => {
        if (!this.selection[data.id]) {
          this.selection[data.id] = data;
        }
      });
    },
    unselectAll() {
      this.results.forEach((data) => {
        delete this.selection[data.id];
      });
    },
  },
};
</script>

<style scoped>
.p-datatable {
  min-height: 350px;
}

@media (max-width: 960px) {
  .select-btn {
    margin-top: 10px !important;
  }
}
</style>
